/** Build-time settings (Vite inlines VITE_* variables). */

/** API base including /api/v1. Default: same origin (the static app and the API behind one domain). */
export function apiBaseUrl(): string {
  const v = (import.meta.env.VITE_API_URL as string | undefined)?.trim();
  if (v) return v.replace(/\/+$/, "");
  return new URL("/api/v1", location.origin).href;
}

/**
 * The web dashboard's address, for the candidate's "समीक्षा" (review) tab (N-PAC, 4 Nov 2026). Default: the
 * field app's own host with "field" → "web" (npac-booth-field.onrender.com → npac-booth-web.onrender.com),
 * or port 3000 on localhost.
 */
export function webBaseUrl(): string {
  const v = (import.meta.env.VITE_WEB_URL as string | undefined)?.trim();
  if (v) return v.replace(/\/+$/, "");
  const h = location.hostname;
  if (h === "localhost" || h === "127.0.0.1") return `${location.protocol}//${h}:3000`;
  if (h.includes("field")) return `${location.protocol}//${h.replace("field", "web")}`;
  return location.origin;
}

/** War-room number for the offline SOS SMS; the SMS button is hidden when it is not set. */
export function warRoomSms(): string | null {
  const v = (import.meta.env.VITE_WARROOM_SMS as string | undefined)?.trim();
  return v ? v : null;
}
